var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "4d51f6da17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 94 L 75 94 L 75 227 L 13 227 Z M 13 94 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d10d2c5f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.964844 0 L 374.964844 226.777344 L 272.695312 343.582031 L 13.695312 116.804688 Z M 115.964844 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff90a2564e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.6875 -6.371094 L 375.023438 226.828125 L 140.835938 494.289062 L -125.5 261.089844 Z M 108.6875 -6.371094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b3e2799e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69 77 L 105 77 L 105 117 L 69 117 Z M 69 77 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ddf3233522"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.964844 0 L 374.964844 226.777344 L 272.695312 343.582031 L 13.695312 116.804688 Z M 115.964844 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef2d29903d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.6875 -6.371094 L 375.023438 226.828125 L 140.835938 494.289062 L -125.5 261.089844 Z M 108.6875 -6.371094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "71a3810d31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93 92 L 365 92 L 365 293 L 93 293 Z M 93 92 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "09031d7dcd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.964844 0 L 374.964844 226.777344 L 272.695312 343.582031 L 13.695312 116.804688 Z M 115.964844 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a4ba38a0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.6875 -6.371094 L 375.023438 226.828125 L 140.835938 494.289062 L -125.5 261.089844 Z M 108.6875 -6.371094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e65deff6d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 81 L 115 81 L 115 126 L 80 126 Z M 80 81 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce6db5d632"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.964844 0 L 374.964844 226.777344 L 272.695312 343.582031 L 13.695312 116.804688 Z M 115.964844 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "943afa4ac6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.6875 -6.371094 L 375.023438 226.828125 L 140.835938 494.289062 L -125.5 261.089844 Z M 108.6875 -6.371094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "40beb0e566"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 246 155 L 342 155 L 342 235 L 246 235 Z M 246 155 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec408e32ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.964844 0 L 374.964844 226.777344 L 272.695312 343.582031 L 13.695312 116.804688 Z M 115.964844 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "516f6200aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.6875 -6.371094 L 375.023438 226.828125 L 140.835938 494.289062 L -125.5 261.089844 Z M 108.6875 -6.371094 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4d51f6da17)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d10d2c5f7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff90a2564e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004b1a",
    d: "M 74.714844 94.476562 C 67.636719 95.375 55.433594 102.902344 47.941406 107.457031 C 28.449219 119.308594 17.59375 127.417969 -0.4375 142.382812 C -12.769531 152.625 -26.175781 163.695312 -36.777344 175.804688 C -49.117188 189.894531 -46.402344 205.265625 -32.941406 217.734375 C -25.921875 224.230469 -15.289062 228.199219 -5.835938 225.8125 C 1.84375 223.871094 16.65625 213.597656 13.671875 204.050781 C 13.085938 202.199219 11.722656 200.695312 10.242188 199.441406 C 4.863281 194.9375 -2.75 193.242188 -9.539062 195.035156 C -10.445312 195.269531 -11.414062 195.621094 -11.886719 196.445312 C -12.804688 198.011719 -11.203125 199.929688 -9.492188 200.539062 C -7.789062 201.140625 -5.835938 201.121094 -4.347656 202.15625 C -1.652344 204.023438 -2.230469 208.242188 -4.382812 210.253906 C -10.335938 215.847656 -20.105469 209.976562 -23.710938 204.484375 C -27.6875 198.449219 -28.136719 190.339844 -25.128906 183.816406 C -18.378906 169.207031 -8.828125 157.144531 3.070312 146.382812 C 6.910156 142.917969 10.867188 139.597656 14.886719 136.328125 C 31.566406 122.742188 53.089844 110.625 71.757812 99.949219 Z M 74.714844 94.476562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b3e2799e2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ddf3233522)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef2d29903d)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.167508, 1.022252, -1.022252, 1.167508, 96.195365, -221.781871)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 133.42004 147.739303 L 126.189437 148.931155 C 124.431038 149.219452 123.239762 150.881489 123.531611 152.640124 L 125.748999 166.139493 C 126.038954 167.899786 127.699333 169.089168 129.459625 168.799213 L 136.689993 167.610913 Z M 133.42004 147.739303 ",
    stroke: "#282727",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#71a3810d31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09031d7dcd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a4ba38a0b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004b1a",
    d: "M 180.210938 136.128906 L 110.738281 92.933594 L 93.992188 119.851562 L 163.46875 163.046875 C 167.710938 165.691406 170.832031 169.785156 172.347656 174.554688 C 176.078125 186.382812 186.5 210.359375 214.933594 228.035156 L 317.96875 292.097656 L 364.292969 217.589844 L 311.601562 184.816406 L 261.269531 153.515625 C 232.835938 135.835938 206.722656 137.085938 194.464844 138.976562 C 189.511719 139.753906 184.464844 138.761719 180.210938 136.128906 Z M 180.210938 136.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e65deff6d8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce6db5d632)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#943afa4ac6)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.167508, 1.022252, -1.022252, 1.167508, 96.195365, -221.781871)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 140.580348 145.939839 L 144.049618 167.028784 C 144.240155 168.190236 143.450779 169.279552 142.290514 169.479087 L 139.55086 169.930629 C 138.389407 170.121166 137.298433 169.329896 137.098898 168.169631 L 133.629629 147.080686 C 133.439092 145.919234 134.228467 144.829918 135.388733 144.630383 L 138.130045 144.180735 C 139.291497 143.990198 140.391469 144.78028 140.580348 145.939839 Z M 140.580348 145.939839 ",
    stroke: "#282727",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#40beb0e566)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec408e32ae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#516f6200aa)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(1.167508, 1.022252, -1.022252, 1.167508, 96.195365, -221.781871)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 296.750854 102.460235 L 300.53024 125.408922 L 248.649428 133.940803 L 244.911297 111.150048 ",
    stroke: "#282727",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.382584, 196.611515)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 26.0625 17.53125 L 20.34375 13.6875 L 25.5 -0.9375 C 25.675781 -1.445312 26.085938 -2.492188 26.734375 -4.078125 C 27.390625 -5.660156 27.859375 -6.707031 28.140625 -7.21875 C 27.679688 -6.664062 26.882812 -5.832031 25.75 -4.71875 C 24.625 -3.601562 23.8125 -2.816406 23.3125 -2.359375 L 11.75 7.90625 L 6.046875 4.0625 L 15.9375 -23.703125 L 20.875 -20.375 L 15.203125 -5.40625 C 14.128906 -2.664062 13.125 -0.332031 12.1875 1.59375 C 12.664062 1.007812 13.453125 0.15625 14.546875 -0.96875 C 15.648438 -2.101562 16.550781 -2.960938 17.25 -3.546875 L 29.609375 -14.5 L 34.359375 -11.3125 L 28.90625 4.296875 C 28.644531 4.992188 28.21875 6.023438 27.625 7.390625 C 27.039062 8.765625 26.503906 9.929688 26.015625 10.890625 C 26.703125 10.117188 27.585938 9.179688 28.671875 8.078125 C 29.753906 6.984375 30.648438 6.113281 31.359375 5.46875 L 43.078125 -5.4375 L 48.03125 -2.125 Z M 26.0625 17.53125 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.467413, 218.19358)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.984375 2 L 18.921875 -21.703125 L 23.953125 -18.3125 L 8.015625 5.390625 Z M 2.984375 2 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.454036, 225.583802)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24 16.140625 L 17.625 11.859375 L 19.375 -13.015625 L 19.234375 -13.109375 C 17.296875 -9.804688 15.875 -7.484375 14.96875 -6.140625 L 7.46875 5.015625 L 2.984375 2 L 18.921875 -21.703125 L 25.265625 -17.4375 L 23.609375 7.234375 L 23.71875 7.3125 C 25.632812 4.132812 27.019531 1.90625 27.875 0.625 L 35.421875 -10.59375 L 39.9375 -7.5625 Z M 24 16.140625 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(262.434465, 243.73236)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16.640625 11.1875 L 2.984375 2 L 18.921875 -21.703125 L 32.578125 -12.515625 L 29.8125 -8.390625 L 21.1875 -14.1875 L 17.6875 -8.984375 L 25.703125 -3.59375 L 22.921875 0.53125 L 14.90625 -4.859375 L 10.8125 1.234375 L 19.4375 7.03125 Z M 16.640625 11.1875 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle3);
export default __webpack_public_path__ + "static/media/bottle3.101676e9a1147ea55d8b3b22d8d5405d.svg";
export { ForwardRef as ReactComponent };